import { Button } from "@/components/shadcn/button";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router";

export type ButtonCancelProps = {
  text: string;
  icon?: IconDefinition,
  tooltip?: string,
  className?: string;
  url?: string;
};

export const ButtonCancel = ({ text, icon, tooltip, className, url }:ButtonCancelProps) => {
  const navigate = useNavigate();

  return (
    <Button
      variant={"outline"}
      type="button"
      title={tooltip}
      className={className}
      size={"sm"}
      onClick={() => {
        if (url && url.trim() !== "") {
          navigate(url);
        } else {
          navigate(-1);
        }
      }}>
      {text} {icon && <FontAwesomeIcon icon={icon} data-testid="icon" /> }
    </Button>
  );
};
